import { useMutation, useQueryClient } from "react-query";
import { addStandard } from "../../../../../actions/Utilities/Standard";
import { toast } from "../../../../../components/toastNotification";
import { StandardInfo } from "../type/StandardInterface";

const useAddStandard = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    (standardNewData: StandardInfo) => addStandard(standardNewData),
    {
      onSuccess: (res: any) => {
        if (res === "Duplicate") {
          toast.fire("Saving Failed", "The data already exists!", "error");
        } else {
          queryClient.invalidateQueries(["GetStandard"]);
          toast.fire("Success", "Standard Added Successfully", "success");
        }
      },
      onError: (error) => {
        toast.fire("Failed", "Failed to Add Standard", "error");
      },
    }
  );

  return mutate;
};
export default useAddStandard;
